import React from "react"
import Layout from "../components/layout/layout"
import SignIn from "../components/signin/signin"

export default function Account() {
  return (
    <Layout>
      <SignIn />
    </Layout>
  )
}
